export default "__VITE_ASSET__phmoPF_y__"